var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv-text",class:{
    red: _vm.red,
    bold: _vm.bold,
    blue: _vm.blue,
    white: _vm.white,
    green: _vm.green,
    remark: _vm.remark,
    yellow: _vm.yellow,
    required: _vm.required,
    h1: _vm.h1,
    h2: _vm.h2,
    'h2-5': _vm.h2_5,
    h3: _vm.h3,
    'h3-5': _vm.h3_5,
    'h3-7': _vm.h3_7,
    h4: _vm.h4,
    h5: _vm.h5,
    h6: _vm.h6,
    'light-gray': _vm.lightGray,
    'ellipsis-2': _vm.isEllipsis2,
    'ellipsis-3': _vm.isEllipsis3,
    'remove-style': _vm.removeStyle,
    'justify-content-center': _vm.justifyCenter,
    'no-wrap': _vm.noWrap,
    wrap: _vm.wrap,
    'bg-yellow': _vm.bgYellow,
    'pre-wrap': _vm.preWrap,
    'min-width-0': _vm.minWidth0,
  },style:({ color: _vm.color, 'text-align': _vm.textAlign }),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }